<template>
  <div class="box">
    <div class="box_1"></div>
    <div class="box_2">
      <div class="t_1">
        <div class="t1">
          <div class="s1"></div>
          <div style="margin-left: 14px">ZZ游戏助手，玩家效率提升利器</div>
        </div>
        <div class="t2">
          ZZ游戏助手致力于为硬核游戏玩家、资深网络用户提供互联互通共享的高效率服务工具，团队秉持着“以用户为本”的核心理念，探索建立全新的系统生态，提升用户系统使用效率。
        </div>
      </div>
      <div class="t_2">
        <div class="t1">以用户为中心</div>
        <div class="t2">
          始终融入用户是我们的核心价值观之一，我们希望我们的产品与用户能坚定地站在一起，与用户真诚交流，倾听用户的意见，打造一款让用户认同，切实满足用户需求的好产品。
        </div>
      </div>
      <div class="t_2">
        <div class="t1">生态共建</div>
        <div class="t2">
          在ZZ游戏助手，我们追求创新、协作和用户导向。我们相信每一个用户都拥有独特的见解和需求，而我们的使命就是为了满足这些需求。我们希望建立一个开放的生态系统，与用户、开发者和合作伙伴一同构建ZZ游戏助手的未来，为每一个人提供定制化的工具和解决方案。
        </div>
      </div>
      <div class="t_2">
        <div class="t1">ZZ游戏助手，共建未来，释放潜能。</div>
        <div class="t2">
          我们追求充满创造力、协作和共赢的世界。我们支持开发者，推动科技进步，让ZZ游戏助手不断进化，以满足用户的不断变化的需求。
        </div>
      </div>
      <div class="t_1">
        <div class="t1">
          <div class="s1"></div>
          <div style="margin-left: 14px">关于绿洲</div>
        </div>
        <div class="t2">
          成都精诚绿洲网络科技有限公司是2019年在四川成都成立的新兴互联网科技公司。我们持续探索，致力打破互联网传统边界，建设新的既个体独立，又社群融合的互联网生态，让人人都能找到归属自己的互联网世界。
        </div>
      </div>
      <div class="kong"></div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  created() {},

  methods: {},
};
</script>
<style scoped lang="less">
.box {
  //   border: 1px solid red;
  width: 100%;
  height: 100%;
  //   background: #000;
  //   background: linear-gradient(to right, #fff,#aaa);
  display: flex;
  flex-direction: column;
  .box_1 {
    width: 100%;
    height: 310px;
    background: url(~@/assets/images/aboutus.png);
    background-size: cover;
    background-repeat: no-repeat;
  }
  .box_2 {
    width: 100%;
    // height: 532px;
    background: #081031;
    display: flex;
    flex-direction: column;
    align-items: center;
    .t_1 {
      width: 642px;
      // height: 148px;
      // border: 1px solid red;
      margin-top: 84px;
      display: flex;
      flex-direction: column;
      .t1 {
        // border: 1px solid red;
        font-size: 34px;
        color: #fff;
        display: flex;
        align-items: center;
        .s1 {
          width: 10px;
          height: 10px;
          border-radius: 50%;
          background: #fff;
        }
      }
      .t2 {
        margin-top: 24px;
        font-size: 20px;
        color: #fff;
      }
    }
    .t_2 {
      width: 642px;
      // height: 148px;
      // border: 1px solid red;
      margin-top: 24px;
      display: flex;
      flex-direction: column;
      .t1 {
        font-size: 24px;
        color: #fff;
      }
      .t2 {
        margin-top: 24px;
        font-size: 16px;
        color: #fff;
      }
    }
    .kong {
      width: 100%;
      height: 84px;
    }
  }
}
</style>
